/**
 * Rocksoft Places API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DeviceState = {
    Unassigned: 'Unassigned',
    Assigned: 'Assigned',
    Spare: 'Spare',
    Unavailable: 'Unavailable',
} as const;
export type DeviceState = typeof DeviceState[keyof typeof DeviceState];

